import request from '@/utils/request'

export const getUsers = (params: any) =>
  request({
    url: '/admin/profile',
    method: 'get',
    params
  })

export const getUserInfo = () =>
  request({
    url: `${process.env.VUE_APP_API_URL}/admin/profile`,
    method: 'get'
  })

export const getUserByName = (username: string) =>
  request({
    url: `/users/${username}`,
    method: 'get'
  })

export const updateUser = (username: string, data: any) =>
  request({
    url: `/users/${username}`,
    method: 'put',
    data
  })

export const deleteUser = (username: string) =>
  request({
    url: `/users/${username}`,
    method: 'delete'
  })

export const login = (data: any) =>
  request({
    url: '/admin/oauth/token',
    method: 'post',
    data
  })

export const logout = (data: any) =>
  request({
    url: '/admin/oauth/revoke',
    method: 'post',
    data
  })

export const register = (data: any) =>
  request({
    url: '/users/register',
    method: 'post',
    data
  })
